import * as PIXI from 'pixi.js';
import Vector from '../Game/Base/Math/Vector';
import CanvasButton from './CanvasButton';
import Global from '../Game/Global';
import { Shape } from './shared';

export default class MoveToCanvasButton extends CanvasButton {
    constructor(parent, blok) {
        super(parent);

        this.position = new Vector(0, 0);
        this.blok = blok;
        this.rotation = 0;
    }

    checkUICollision(position) {
        if (!this._hasVisuals)
            return false;
        const pixiPoint = new PIXI.Point();
        this.pixiContainer.worldTransform.applyInverse(position.makePIXIPoint(), pixiPoint);
        const buttonSpacePosition = Vector.fromPIXIPoint(pixiPoint);

        if (buttonSpacePosition.x < -this.pixiContainer.width / 2)
            return false;
        if (buttonSpacePosition.y < -this.pixiContainer.height / 2)
            return false;
        if (buttonSpacePosition.x > +this.pixiContainer.width / 2)
            return false;
        if (buttonSpacePosition.y > +this.pixiContainer.height / 2)
            return false;

        return true;
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.pixiGraphics = new PIXI.Graphics();

        this.pixiContainer.addChild(this.pixiGraphics);
        this.getParentPixiContainer().addChild(this.pixiContainer);

        this.pixiContainer.x = this.position.x;
        this.pixiContainer.y = this.position.y;
    }

    onUpdateVisuals() {
        this.pixiGraphics.clear();
        this.pixiGraphics.lineStyle(2.1, 0xb4ea04);
        this.pixiGraphics.beginFill(0xffffff, 0.2);
        if (this.blok.shape === Shape.rectangle) {
            this.pixiGraphics.drawRect(
                -this.blok.size.x * Global.NATIVE_BLOCK_SIZE / 2 + 1, 
                -this.blok.size.y * Global.NATIVE_BLOCK_SIZE / 2 + 1, 
                this.blok.size.x * Global.NATIVE_BLOCK_SIZE - 2, 
                this.blok.size.y * Global.NATIVE_BLOCK_SIZE - 2);
        }
        else {
            this.pixiGraphics.drawCircle(0, 0, (this.blok.size.x * Global.NATIVE_BLOCK_SIZE - 2) / 2);
        }
        this.pixiGraphics.endFill();

        this.pixiContainer.x = this.position.x;
        this.pixiContainer.y = this.position.y;
        this.pixiContainer.rotation = this.rotation;
    }

    onDestroyVisuals() {
        this.pixiGraphics.destroy();
        this.pixiContainer.destroy();
    }
}